import { useEffect, useRef } from 'react';

const useInterval = (callback, delay, instantly) => {
	const savedCallback = useRef();

	// Remember the latest callback.
	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	// Set up the interval.
	useEffect(() => {
		const tick = () => {
			if (typeof savedCallback?.current === 'function') {
				savedCallback.current();
			} else {
				console.log('not func', delay);
			}
		};
		if (instantly) {
			savedCallback.current();
		}

		let id;
		if (delay !== null) {
			id = setInterval(tick, delay);
		}
		return () => id && clearInterval(id);
	}, [delay, instantly]);
};

export default useInterval;
